import { Campaign } from "../classes/campaign";
import { hexTestMap } from "./map";
import { allFactions } from "./factions";

export const theBattleForTheChorizo = new Campaign("test_campaign", "The Batlle for the chorizo", 1000, hexTestMap, allFactions, 4, 'weeks');

//